class OrderDesc {
  /** asc */
  asc = false;

  /** col */
  col = "";
}

class PageResult {
  /** current */
  current = undefined;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new PageResult();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class SkuWarehouseStockCo {
  /** sku编号 */
  skuNo = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** sku仓库可用库存 */
  warehouseUseQty = undefined;
}

class SkuWarehouseStockGetQry {
  /** SKU编号 */
  skuNo = "";

  /** 指定仓库列表 */
  warehouseCodeList = [];
}

class StockMatchingQry {
  /** 平台编号 */
  platformCode = "";

  /** 是否共享平台 */
  sharedPlatformFlag = false;

  /** sku明细 */
  skuQries = [];

  /** 交易主体编号 */
  transactionMainCode = "";
}

class StockMatchingSkuQry {
  /** 数量 */
  qty = undefined;

  /** sku */
  skuNo = "";
}

class StockOrderAdjustingCmd {
  /** 调整单 */
  stockOrderCo = new StockOrderCo();
}

class StockOrderCo {
  /** 关联单号 */
  correlationNo = "";

  /** 关联单据类型 */
  correlationType = undefined;

  /** 是否需要处理在途库存,目前只有调拨单传true，其他单据不要传 */
  handleTransitFlag = false;

  /** 是否针对已经锁定的数量进行分批出库 */
  lockBatchOutFlag = false;

  /** 是否需要先锁定再出库，默认需要先进行锁定在出库，传false则不需要先锁定，直接出库，例如FBA订单 */
  lockFirstFlag = false;

  /** 操作单号 */
  operationNo = "";

  /** 操作单据类型 */
  operationOrderType = undefined;

  /** operationType */
  operationType = "ADJUSTING";

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 出库方式 默认0：:指定平台，但是指定平台库存不足则取共享库存 1：指定平台，例如平台库存转移 2：按照销售比例出库，例如三方仓盘点，报损等按照出库比例 */
  outboundMethod = undefined;

  /** 平台编号，如果出库方式是按照比例出库，outboundMethod传的是2，此时的平台编号是一个列表，用英文分号分割开 */
  platformCode = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 母仓库英文名称 */
  rootWarehouseNameEn = "";

  /** sku明细 */
  stockDetailList = [];

  /** 目标组织编号 */
  targetOrganizeCode = "";

  /** 目标组织名称 */
  targetOrganizeName = "";

  /** 目标平台 */
  targetPlatformCode = "";

  /** 目标母仓编号 */
  targetRootWarehouseCode = "";

  /** 目标母仓名称 */
  targetRootWarehouseName = "";

  /** 目标母仓英文名称 */
  targetRootWarehouseNameEn = "";

  /** 目标主体编号 */
  targetTransactionMainCode = "";

  /** 目标主体名称 */
  targetTransactionMainName = "";

  /** 目标仓库编号 */
  targetWarehouseCode = "";

  /** 目标仓库名称 */
  targetWarehouseName = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 事务id */
  transactionNo = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockOrderDetailCo {
  /** 产品名称 */
  productName = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  skuNo = "";
}

class StockOrderFreezeCmd {
  /** 冻结库存单 */
  stockOrderCo = new StockOrderCo();
}

class StockOrderInboundCmd {
  /** 入库单 */
  stockOrderCo = new StockOrderCo();
}

class StockOrderLockingCmd {
  /** 锁定库存单 */
  stockOrderCo = new StockOrderCo();
}

class StockOrderLossCmd {
  /** 冻结库存单 */
  freezeStockOrderCo = new StockOrderCo();

  /** 报损库存单 */
  stockOrderCo = new StockOrderCo();
}

class StockOrderOutboundCmd {
  /** 入库单 */
  stockOrderCo = new StockOrderCo();
}

class StockOrderUnfreezeCmd {
  /** 冻结库存单 */
  stockOrderCo = new StockOrderCo();
}

class StockOrderUnlockingCmd {
  /** 锁定库存单 */
  stockOrderCo = new StockOrderCo();
}

class StockSkuAndCompanyCoReq {
  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class StockSkuAndCompanyCoRes {
  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockSkuAndWarehouseCo {
  /** sku */
  sku = "";

  /** 库存sku主体 */
  stockSkuAndCompanyCoList = [];

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockSkuChangeRecordResponseDto {
  /** 锁定数量快照 */
  beforeLockQty = undefined;

  /** 在途数量快照 */
  beforeTransitQty = undefined;

  /** 可用数量快照 */
  beforeUseQty = undefined;

  /** 来源单号 */
  correlationNo = "";

  /** 关联单据类型 */
  correlationType = undefined;

  /** 操作人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 锁定数量变动 */
  lockQtyChg = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 操作单号 */
  operationNo = "";

  /** 操作订单类型 1：出库计划单 2：入库计划单 3：库存调整单 4：库存平台转移单 */
  operationOrderType = undefined;

  /** 操作类型 1 入库 2 出库 3 调整 4 锁定 5 解锁 */
  operationType = undefined;

  /** 平台编号 */
  platformCode = "";

  /** 产品名称 */
  productName = "";

  /** 仓库编号 */
  rootWarehouseCode = "";

  /** 仓库名称 */
  rootWarehouseName = "";

  /** SKU编号 */
  skuNo = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 事务id全局唯一 */
  transactionNo = "";

  /** 在途数量变动 */
  transitQtyChg = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 可用数量变动 */
  useQtyChg = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 子库名称 */
  warehouseName = "";
}

class StockSkuCo {
  /** 军团名称 */
  corpsName = "";

  /** 锁定数量 */
  lockQty = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 产品名称 */
  productName = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 母仓库英文名称 */
  rootWarehouseNameEn = "";

  /** sku */
  sku = "";

  /** SPU编号 */
  spu = "";

  /** 在库数量 */
  stockQty = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 在途数量 */
  transitQty = undefined;

  /** 可用数量 */
  useQty = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 子库名称 */
  warehouseName = "";
}

class StockSkuCompanyCo {
  /** 军团名称 */
  corpsName = "";

  /** 锁定数量 */
  lockQty = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 产品名称 */
  productName = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 母仓库英文名称 */
  rootWarehouseNameEn = "";

  /** sku */
  sku = "";

  /** SPU编号 */
  spu = "";

  /** 在库数量 */
  stockQty = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 在途数量 */
  transitQty = undefined;

  /** 可用数量 */
  useQty = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 子库名称 */
  warehouseName = "";
}

class StockSkuDetailCo {
  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** 超出标识，0：否，1：是 */
  excessFlag = undefined;

  /** 产品名称 */
  productName = "";

  /** sku */
  sku = "";

  /** spu */
  spu = "";

  /** 库存sku仓库 */
  stockSkuAndWarehouseCoList = [];

  /** 总数量 */
  totalQty = undefined;
}

class StockSkuGetAllQry {
  /** SKU编号 */
  sku = "";

  /** 主体列表 */
  stockSkuCompanyCoList = [];

  /** 仓库列表 */
  stockWarehouseDetailCos = [];
}

class StockSkuGetQry {
  /** 平台编号 */
  platformCode = "";

  /** SKU编号 */
  sku = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 子库编号 */
  warehouseCode = "";
}

class StockSkuListQry {
  /** current */
  current = undefined;

  /** 最大锁定数量 */
  lockQtyMax = undefined;

  /** 最小锁定数量 */
  lockQtyMin = undefined;

  /** needTotalCount */
  needTotalCount = false;

  /** orderDescs */
  orderDescs = [];

  /** 组织编号 */
  organizeCode = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库编号列表 */
  rootWarehouseCodeList = [];

  /** size */
  size = undefined;

  /** SKU编号 */
  sku = "";

  /** SKU编号列表 */
  skus = [];

  /** SPU编号 */
  spu = "";

  /** 最大在库数量 */
  stockQtyMax = undefined;

  /** 最小在库数量 */
  stockQtyMin = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 最大在途数量 */
  transitQtyMax = undefined;

  /** 最小在途数量 */
  transitQtyMin = undefined;

  /** 最大可用数量 */
  useQtyMax = undefined;

  /** 最小可用数量 */
  useQtyMin = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 仓库编号列表 */
  warehouseCodeList = [];
}

class StockSkuOccupyCo {
  /** 关联单号 */
  correlationNo = "";

  /** 日期 */
  createTime = "";

  /** 操作单号 */
  operationNo = "";

  /** 操作单据类型 */
  operationOrderType = undefined;

  /** 产品名称 */
  productName = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  skuNo = "";

  /** 库存类型 1:可用 2:锁定 3:冻结 */
  stockType = undefined;
}

class StockSkuPageListQry {
  /** current */
  current = undefined;

  /** 最大锁定数量 */
  lockQtyMax = undefined;

  /** 最小锁定数量 */
  lockQtyMin = undefined;

  /** needTotalCount */
  needTotalCount = false;

  /** orderDescs */
  orderDescs = [];

  /** 组织编号 */
  organizeCode = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库编号列表 */
  rootWarehouseCodeList = [];

  /** size */
  size = undefined;

  /** SKU编号 */
  sku = "";

  /** SKU编号列表 */
  skus = [];

  /** SPU编号 */
  spu = "";

  /** 最大在库数量 */
  stockQtyMax = undefined;

  /** 最小在库数量 */
  stockQtyMin = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 最大在途数量 */
  transitQtyMax = undefined;

  /** 最小在途数量 */
  transitQtyMin = undefined;

  /** 最大可用数量 */
  useQtyMax = undefined;

  /** 最小可用数量 */
  useQtyMin = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 仓库编号列表 */
  warehouseCodeList = [];
}

class StockSkuPlatformCo {
  /** 军团名称 */
  corpsName = "";

  /** 锁定数量 */
  lockQty = undefined;

  /** 组织编号 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 平台编号 */
  platformCode = "";

  /** 平台名称 */
  platformName = "";

  /** 产品名称 */
  productName = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库名称 */
  rootWarehouseName = "";

  /** 母仓库英文名称 */
  rootWarehouseNameEn = "";

  /** sku */
  sku = "";

  /** SPU编号 */
  spu = "";

  /** 在库数量 */
  stockQty = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 在途数量 */
  transitQty = undefined;

  /** 可用数量 */
  useQty = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 子库名称 */
  warehouseName = "";
}

class StockSkuPlatformListQry {
  /** current */
  current = undefined;

  /** 最大锁定数量 */
  lockQtyMax = undefined;

  /** 最小锁定数量 */
  lockQtyMin = undefined;

  /** needTotalCount */
  needTotalCount = false;

  /** orderDescs */
  orderDescs = [];

  /** 组织编号 */
  organizeCode = "";

  /** 平台编号 */
  platformCode = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库编号列表 */
  rootWarehouseCodeList = [];

  /** size */
  size = undefined;

  /** SKU编号 */
  sku = "";

  /** SKU编号列表 */
  skus = [];

  /** SPU编号 */
  spu = "";

  /** 最大在库数量 */
  stockQtyMax = undefined;

  /** 最小在库数量 */
  stockQtyMin = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 最大在途数量 */
  transitQtyMax = undefined;

  /** 最小在途数量 */
  transitQtyMin = undefined;

  /** 最大可用数量 */
  useQtyMax = undefined;

  /** 最小可用数量 */
  useQtyMin = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 子库编号列表 */
  warehouseCodeList = [];
}

class StockSkuPlatformPageListQry {
  /** current */
  current = undefined;

  /** 最大锁定数量 */
  lockQtyMax = undefined;

  /** 最小锁定数量 */
  lockQtyMin = undefined;

  /** needTotalCount */
  needTotalCount = false;

  /** orderDescs */
  orderDescs = [];

  /** 组织编号 */
  organizeCode = "";

  /** 平台编号 */
  platformCode = "";

  /** 母仓库编号 */
  rootWarehouseCode = "";

  /** 母仓库编号列表 */
  rootWarehouseCodeList = [];

  /** size */
  size = undefined;

  /** SKU编号 */
  sku = "";

  /** SKU编号列表 */
  skus = [];

  /** SPU编号 */
  spu = "";

  /** 最大在库数量 */
  stockQtyMax = undefined;

  /** 最小在库数量 */
  stockQtyMin = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 最大在途数量 */
  transitQtyMax = undefined;

  /** 最小在途数量 */
  transitQtyMin = undefined;

  /** 最大可用数量 */
  useQtyMax = undefined;

  /** 最小可用数量 */
  useQtyMin = undefined;

  /** 子库编号 */
  warehouseCode = "";

  /** 子库编号列表 */
  warehouseCodeList = [];
}

class StockSkuPlatformQry {
  /** current */
  current = undefined;

  /** needTotalCount */
  needTotalCount = false;

  /** orderDescs */
  orderDescs = [];

  /** 平台编号 */
  platformCode = "";

  /** size */
  size = undefined;

  /** SKU编号 */
  sku = "";

  /** 子库编号 */
  warehouseCode = "";
}

class StockSkuTrandeQty {
  /** sku明细 */
  skuQries = [];

  /** 交易主体编号 */
  transactionMainCode = [];

  /** 仓库编号 */
  warehouseCode = "";
}

class StockWarehouseCo {
  /** 交易主体编号 */
  platformCode = "";

  /** 数量 */
  qty = undefined;

  /** sku */
  skuNo = "";

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockWarehouseDetailCo {
  /** 仓库编号 */
  warehouseCode = "";

  /** 仓库名称 */
  warehouseName = "";
}

class StockWarehousePlatformSkuQry {
  /** 平台编号 */
  platformCode = "";

  /** sku编号明细 */
  skuNoList = [];

  /** 仓库编号 */
  warehouseCode = "";
}

export const stock = {
  OrderDesc,
  PageResult,
  Response,
  ResponseDto,
  SkuWarehouseStockCo,
  SkuWarehouseStockGetQry,
  StockMatchingQry,
  StockMatchingSkuQry,
  StockOrderAdjustingCmd,
  StockOrderCo,
  StockOrderDetailCo,
  StockOrderFreezeCmd,
  StockOrderInboundCmd,
  StockOrderLockingCmd,
  StockOrderLossCmd,
  StockOrderOutboundCmd,
  StockOrderUnfreezeCmd,
  StockOrderUnlockingCmd,
  StockSkuAndCompanyCoReq,
  StockSkuAndCompanyCoRes,
  StockSkuAndWarehouseCo,
  StockSkuChangeRecordResponseDto,
  StockSkuCo,
  StockSkuCompanyCo,
  StockSkuDetailCo,
  StockSkuGetAllQry,
  StockSkuGetQry,
  StockSkuListQry,
  StockSkuOccupyCo,
  StockSkuPageListQry,
  StockSkuPlatformCo,
  StockSkuPlatformListQry,
  StockSkuPlatformPageListQry,
  StockSkuPlatformQry,
  StockSkuTrandeQty,
  StockWarehouseCo,
  StockWarehouseDetailCo,
  StockWarehousePlatformSkuQry,
};
